module.exports = __webpack_public_path__ + "static/media/mobile_phone_case.a24759c5.webp";